import toast from "react-hot-toast";

import { useAuth } from "../AuthProvider";

export const showStreakMilestoneNotification = (currentStreak: number) => {
  toast.custom(
    (t) => (
      <StreakMilestoneNotification days={currentStreak} visible={t.visible} />
    ),
    { duration: 5000, id: `streak-${currentStreak}` }
  );
};

function StreakMilestoneNotification({
  days,
  visible,
}: {
  days: number;
  visible: boolean;
}) {
  const { user } = useAuth();
  const userName =
    user?.user_metadata?.full_name || user?.email?.split("@")[0] || "User";

  return (
    <div
      className={
        visible ? "animate-notification-enter" : "animate-notification-leave"
      }
    >
      <div className="flex items-center space-x-3 bg-white dark:bg-slate-800 rounded-full px-4 py-3 shadow-lg min-w-[280px]">
        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center text-2xl relative">
          🔥
          <div className="absolute -top-1 -right-1 bg-orange-400 text-orange-900 text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
            {days}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-slate-900 dark:text-white truncate">
            {userName}
          </div>
          <div className="text-sm text-slate-600 dark:text-slate-300">
            {days} day streak!
          </div>
        </div>
      </div>
    </div>
  );
}

export default StreakMilestoneNotification;
